enum CardButtonIcon {
  INFO,
  PLAN,
  PLAY,
}

enum CardType {
  HORIZONTAL,
  VERTICAL,
}

export { CardButtonIcon, CardType };
